import { Component, OnInit, Input } from '@angular/core';
import { ProjectService } from '../../../api/services/project.services';
import { TransactionSummary, Transaction } from '../../../api/models/transaction-summary';

@Component({
  selector: 'app-project-spending-summary',
  templateUrl: './project-spending-summary.component.html',
  styleUrls: ['./project-spending-summary.component.scss']
})
export class ProjectSpendingSummaryComponent implements OnInit {

  @Input() projectId: string;

  filter = 'No';

  merchandiseTotal: number;
  taxTotal: number;
  shippingTotal: number;
  total: number;
  consignedTotal: number;
  transactionSummary: TransactionSummary;

  constructor(private projectService: ProjectService) { }


  changeFilter(filter: string) {
    this.filter = filter;
    if (this.filter === 'Yes') {
      this.restartValues();
      this.populateTable(this.transactionSummary.orderTransactions);
      this.populateTable(this.transactionSummary.quoteTransactions);
    } else {
      this.restartValues();
      this.populateTable(this.transactionSummary.orderTransactions);
    }
  }

  restartValues() {
    this.merchandiseTotal = 0;
    this.taxTotal = 0;
    this.shippingTotal = 0;
    this.total = 0;
    this.consignedTotal = 0;
  }

  populateTable(transactions: Transaction[]) {
    transactions.forEach(transaction => {
      this.merchandiseTotal += transaction.totalMerchandiseAmountToShip;
      this.taxTotal += transaction.totalTaxAmount;
      this.shippingTotal += transaction.totalShippingAndHandlingAmount;
      this.total += transaction.totalAmount;
      this.consignedTotal += transaction.consignmentTotal;
    });
  }

  ngOnInit() {
    this.projectService.getProjectTransactionSummary(this.projectId).subscribe(transactionsSummary => {
      this.transactionSummary = transactionsSummary;
      this.restartValues();
      this.populateTable(transactionsSummary.orderTransactions);
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-spending-summary/project-spending-summary.component.ts